/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'

import aaveQuestions from 'images/coin-pages/questions/aave.svg'

import { commonLearnMoreData, commonSlidesData } from '../commonPageData'

export const aavePage: ICoinPageData = {
  title: 'coin_1',
  description: 'coin_2',
  metaTitle: 'aave_loan_meta_title',
  metaDescription: 'aave_loan_meta_desc',
  calculatorTitle: 'borrow_against_aave',
  h1: (t) => (
    <span dangerouslySetInnerHTML={{ __html: t('get_aave_loan') }} />
  ),
  questionsBlock: {
    image: aaveQuestions,
    questions: [
      {
        title: 'coin_3',
        answer: 'coin_4',
      },
      {
        title: 'coin_5',
        answer: 'coin_6',
      },
      {
        title: 'coin_7',
        answer: 'coin_8',
      },
      {
        title: 'coin_9',
        answer: 'coin_10',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Aave (AAVE)'),
    text: [],
    learnMoreTitle: 'learn_more_about_name_lending',
    paragraphs: [
      {
        title: 'coin_11',
        text: ['coin_15'],
      },
      {
        title: 'coin_12',
        text: ['coin_16', 'coin_17', 'coin_18', 'coin_19'],
      },
      {
        title: 'coin_13',
        text: ['coin_21', 'coin_22', 'coin_23', 'coin_24'],
      },
    ],
    ...commonLearnMoreData('Aave (AAVE)'),
  },
  videoId: 'EzqiPJBCVvs',
  videoTitle: 'coin_14',
}
